/* Circuit Hero - product variant swatch click compatibility */
(function(){
  function initVariantSwatchClicks(root){
    if(!root || root.dataset.chSwatchCompat === '1') return;
    root.dataset.chSwatchCompat='1';
    root.addEventListener('click', function(event){
      const label=event.target.closest('label.product-form__label');
      if(!label || !root.contains(label)) return;
      const id=label.getAttribute('for');
      if(!id) return;
      const input=root.querySelector('#'+CSS.escape(id));
      if(!input || input.disabled) return;
      // Some Ella 7.x CSS/markup combinations prevent the native label activation.
      // Explicitly select the radio and fire the same change event used by VariantRadios.
      if(!input.checked){
        event.preventDefault();
        input.checked=true;
        input.dispatchEvent(new Event('change',{bubbles:true}));
      }
      // Keep the visible option name synchronized immediately.
      const fieldset=input.closest('.product-form__input');
      const header=fieldset && fieldset.querySelector('[data-header-option]');
      if(header) header.textContent=input.value;
    }, true);
  }
  function boot(){
    document.querySelectorAll('variant-radios').forEach(initVariantSwatchClicks);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  new MutationObserver(boot).observe(document.documentElement,{childList:true,subtree:true});
})();
